import { useEffect, useState } from "react";
import { reformatAnalysisData } from "../../../util/helperFunctions";
import { changeZeroToNull, unitConversion } from "../util/analysisUtils";
import moment from "moment";
import { toast } from "react-toastify";
import { fetchExpressions } from "../../../api/sensorApi";

function useFetchCmlData({
    cmlIDs, start, end, interval, passedFeature, context
}) {
    const [cmlData, setCmlData] = useState();
    const [cmlDataLoading, setCmlDataLoading] = useState(false);

    useEffect(() => {
        if (cmlIDs != null && cmlIDs.length > 0 && moment(start).toDate().toString() !== "Invalid Date" && moment(end).toDate().toString() !== "Invalid Date") {
            setCmlDataLoading(true);
            fetchExpressions( "CMLExpression", {
                    ids: cmlIDs,
                    expressions: passedFeature.map(ele => ele.id),
                    start: moment(start).format("YYYY-MM-DD"),
                    end: moment(end).format("YYYY-MM-DD"),
                    interval: interval.value,
                    units: passedFeature.map(ele => unitConversion(ele.id, context.units))
            }).then((cmlData) => {
                cmlData = reformatAnalysisData(cmlData);
                cmlData = changeZeroToNull(cmlData);
                setCmlData(cmlData);
                setCmlDataLoading(false);
            }).catch(err => {
                console.log(err);
                setCmlDataLoading(false);
                toast.error("error fetching cml data")
            });
        }
        else setCmlData();
    }, [cmlIDs, start, end, interval.value, passedFeature, context.units]);

    return { cmlData, cmlDataLoading }
}

export default useFetchCmlData;